var _circle, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9354 15.6758H10.838V25.5534H13.9354V15.6758Z",
    fill: "#7F00E2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3142 15.4618C22.2 15.4475 22.0787 15.4404 21.9574 15.4332C20.2231 15.3619 19.2453 16.3896 18.9028 16.8321C18.81 16.9534 18.7672 17.0248 18.7672 17.0248V15.7044H15.8053V25.582H18.7672H18.9028C18.9028 24.5757 18.9028 23.5765 18.9028 22.5702C18.9028 22.0278 18.9028 21.4854 18.9028 20.943C18.9028 20.2721 18.8528 19.5584 19.1882 18.9446C19.4737 18.4308 19.9876 18.1738 20.5657 18.1738C22.2786 18.1738 22.3142 19.7226 22.3142 19.8653C22.3142 19.8724 22.3142 19.8796 22.3142 19.8796V25.6249H25.4117V19.1801C25.4117 16.9748 24.2912 15.6759 22.3142 15.4618Z",
    fill: "#7F00E2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3867 14.3978C13.38 14.3978 14.1852 13.5926 14.1852 12.5993C14.1852 11.606 13.38 10.8008 12.3867 10.8008C11.3934 10.8008 10.5881 11.606 10.5881 12.5993C10.5881 13.5926 11.3934 14.3978 12.3867 14.3978Z",
    fill: "#7F00E2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/linkedIn.30e199a42164d1ac27b738efd51a0f2f.svg";
export { ForwardRef as ReactComponent };